// Array item splitter for bracket syntax parsing.
// Example: "a, fn(1,2), 'x,y'" -> ["a", "fn(1,2)", "'x,y'"].

// Split top-level array items while preserving nested and quoted commas.
export function splitArrayItems(input: string): string[] {
  const parts: string[] = []
  let current = ''
  let quote: "'" | '"' | null = null
  let depthParen = 0
  let depthBrace = 0
  let depthBracket = 0

  // Walk source chars and split only on top-level commas.
  for (let i = 0; i < input.length; i += 1) {
    const char = input[i]
    const previousChar = i > 0 ? input[i - 1] : ''

    // Keep quoted text untouched until matching quote is reached.
    if (quote) {
      current += char
      if (char === quote && previousChar !== '\\') {
        quote = null
      } else {
        // Continue reading quoted text.
      }
      continue
    } else {
      // Continue scanning outside quoted context.
    }

    // Enter quote mode when parser finds an opening quote.
    if (char === "'" || char === '"') {
      quote = char
      current += char
      continue
    } else {
      // Continue nested scope depth tracking.
    }

    // Track nested scope depth to avoid splitting nested commas.
    if (char === '(') {
      depthParen += 1
    } else if (char === ')' && depthParen > 0) {
      depthParen -= 1
    } else if (char === '{') {
      depthBrace += 1
    } else if (char === '}' && depthBrace > 0) {
      depthBrace -= 1
    } else if (char === '[') {
      depthBracket += 1
    } else if (char === ']' && depthBracket > 0) {
      depthBracket -= 1
    } else {
      // Keep depth counters unchanged.
    }

    // Split item only when comma appears at top-level scope.
    if (char === ',' && depthParen === 0 && depthBrace === 0 && depthBracket === 0) {
      const token = current.trim()
      if (token.length > 0) {
        parts.push(token)
      } else {
        // Skip empty token between top-level commas.
      }
      current = ''
      continue
    } else {
      // Keep collecting current token.
    }

    current += char
  }

  const lastToken = current.trim()
  // Push trailing token when source does not end with a comma.
  if (lastToken.length > 0) {
    parts.push(lastToken)
  } else {
    // Keep parts unchanged when last token is empty.
  }

  // Return parsed top-level array items.
  return parts
}

// Detect whether token starts and ends with the same quote type.
export function isQuoted(token: string): boolean {
  // Return false when token is shorter than a quoted literal.
  if (token.length < 2) {
    return false
  } else {
    // Continue quote wrapper validation.
  }

  const first = token[0]
  const last = token[token.length - 1]
  // Return true for wrapped single/double-quoted tokens.
  return (first === "'" && last === "'") || (first === '"' && last === '"')
}
